import { render, staticRenderFns } from "./v-document-upload-popup.vue?vue&type=template&id=119bb22b&scoped=true"
import script from "./v-document-upload-popup.vue?vue&type=script&lang=js"
export * from "./v-document-upload-popup.vue?vue&type=script&lang=js"
import style0 from "./v-document-upload-popup.vue?vue&type=style&index=0&id=119bb22b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119bb22b",
  null
  
)

export default component.exports